import { render, staticRenderFns } from "./TemplateDraggableInputComponent.vue?vue&type=template&id=3bbc8555&scoped=true&"
import script from "./TemplateDraggableInputComponent.vue?vue&type=script&lang=js&"
export * from "./TemplateDraggableInputComponent.vue?vue&type=script&lang=js&"
import style0 from "./TemplateDraggableInputComponent.vue?vue&type=style&index=0&id=3bbc8555&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bbc8555",
  null
  
)

export default component.exports